import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=3b5992d2&"
import script from "./CreateEvent.vue?vue&type=script&lang=ts&"
export * from "./CreateEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports